module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myclass",
    attrs: {
      "id": "نرجسية"
    }
  }, [_c('div', {
    staticClass: "section level2",
    staticStyle: {
      "padding-top": "130px"
    },
    attrs: {
      "id": "narcissistic"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تلعب مع الشيطان فتذهب إلى الجحيم.")])]), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Don’t mess up with Satan, you may go to hell.")]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمر مشابه إلى \"ألم تخبرك والدتك ألا تلعب بالنار!\"")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هُنا يأتي تحذيرٌ آخر، فالبشر صنعوا جزءاً من شيطانِ وملاك")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("البعض يطغى عليه الجزء السيئ، لذا قد ينتهي بك المطاف تلتقي بهم")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وتواجههم وترى الجحيم.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("It’s the same of “Doesn’t your mother told you don’t play with fire!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Here comes the second warning, the human is made of half of the angel and the other half is Satan.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("And some are totally controlled by the other half Satan, so you may end up meet them and face them so you may see hell.")]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لذا تجاهل، وكُن حذراً.. اللعب دائماً لا يعني شيئاً جميلاً.")])]), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("So, ignore them and be careful, playing does not always mean a beautiful thing.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("******")]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcfcf944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0009.vue
// module id = 111
// module chunks = 0